import { FETCH_SHIFT_SUCCESS } from 'common/constants/actionTypes';
import Immutable from 'immutable';

export const shift = (state = Immutable.fromJS({ records: [] }), action) => {
    switch (action.type) {
        case FETCH_SHIFT_SUCCESS: {
            const shifts = Immutable.fromJS(action.response);
            return state.set('records', shifts);
        }

        default:
            return state;
    }
};
